<template>
  <Icon-Template :size="size">
    <svg viewBox="0 0 12 10" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.00048 9.15863C2.00006 9.05982 1.99965 9.13079 2.00048 9.15863V9.15863Z"/>
      <path d="M11.1265 9.23446C11.1278 9.20773 11.1269 9.04897 11.1265 9.23446V9.23446Z"/>
      <path d="M6 4.88195L5.88298 4.97762C5.88298 4.97776 5.88294 4.97795 5.88287 4.97822C5.88281 4.97849 5.88277 4.97869 5.88277 4.97883V5.0757C5.88277 5.0792 5.88406 5.08223 5.88664 5.08479C5.88922 5.08734 5.89227 5.08863 5.8958 5.08863H5.97395V5.01112H6.02605V5.08863H6.1042C6.10773 5.08863 6.11079 5.08735 6.11336 5.08479C6.11594 5.08224 6.11723 5.0792 6.11723 5.0757V4.97883C6.11723 4.97829 6.11716 4.97788 6.11703 4.97762L6 4.88195Z"/>
      <path d="M7.9545 5.03012L12 7.56634V2.38679L7.9545 5.03012Z"/>
      <path d="M0 2.38679V7.56634L4.0455 5.03012L0 2.38679Z"/>
      <path d="M11.25 0.878448H0.749999C0.375749 0.878448 0.0787491 1.15513 0.0224991 1.51139L6 5.41687L11.9775 1.51139C11.9213 1.15513 11.6243 0.878448 11.25 0.878448Z"/>
      <path d="M7.2675 5.47935L6.20625 6.17254C6.14325 6.21344 6.072 6.23352 6 6.23352C5.928 6.23352 5.85675 6.21344 5.79375 6.17254L4.7325 5.47861L0.0240011 8.43208C0.0817511 8.78537 0.377251 9.05981 0.750001 9.05981H11.25C11.6228 9.05981 11.9183 8.78537 11.976 8.43208L7.2675 5.47935Z"/>
    </svg>
  </Icon-Template>
</template>

<script>

import IconTemplate from '@/components/icons/Template'

export default {
  props: ['size'],
  components: { IconTemplate }
}
</script>
